import React from 'react';
import { Box, Typography } from '@mui/material';

interface HeatmapData {
  name: string;
  data: Array<{
    x: string;
    y: number;
  }>;
}

interface HeatmapProps {
  data: HeatmapData[];
}

function Heatmap({ data }: HeatmapProps) {
  if (!data || data.length === 0) {
    return (
      <Box sx={{ p: 2, textAlign: 'center' }}>
        <Typography variant="body2" color="text.secondary">
          No data available
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ p: 2 }}>
      {data.map((item, index) => (
        <Box key={index} sx={{ mb: 2 }}>
          <Typography variant="subtitle2" sx={{ mb: 1 }}>
            {item.name}
          </Typography>
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
            {item.data.slice(0, 10).map((point, pointIndex) => (
              <Box
                key={pointIndex}
                sx={{
                  width: 20,
                  height: 20,
                  bgcolor: `rgba(0, 174, 239, ${Math.min(point.y, 1)})`,
                  borderRadius: 1,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '0.7rem',
                  color: point.y > 0.5 ? 'white' : 'text.primary',
                }}
                title={`${point.x}: ${point.y.toFixed(2)}`}
              >
                {point.y > 0.1 ? point.y.toFixed(1) : ''}
              </Box>
            ))}
          </Box>
        </Box>
      ))}
    </Box>
  );
}

export default Heatmap; 